module.exports = __webpack_public_path__ + "static/media/Andrea Alstad Headshot.d908e641.png";